module.exports = __webpack_public_path__ + "media/images/carousel/banner_4-e83576a8f75b767e302f12f0266ea9f9.jpg";